import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";
import { TickCircleOutlineIcon } from "../Icons/TickCircleOutlineIcon";
import { ShapeCircleIcon } from "../Icons/ShapeCircleIcon";
import { cn } from "@/utils/styles";
import { WarnTriangleIcon } from "../Icons/WarnTriangleIcon";
import { AlertCircleRedIcon } from "@/components/Icons/AlertCircleRedIcon.tsx";
import { InfoCircleIcon } from "@/components/Icons/InfoCircleIcon.tsx";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function (props) {
        const { id, title, description, action, ...rest } = getVariantToastProps(props);

        return (
          <Toast key={id} {...rest}>
            <ToastClose />
            <div className="grid w-full justify-start gap-1 p-[6px]">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}

const getVariantToastProps = ({
  variant,
  title,
  className,
  ...rest
}: ReturnType<typeof useToast>["toasts"][0]) => {
  const toastIcon = VARIANT_ICON_MAP[(variant || "default") as keyof typeof VARIANT_ICON_MAP];

  return {
    ...rest,
    variant,
    className: cn(className),
    title: (
      <div className="flex flex-row items-center gap-2">
        {toastIcon && (
          <toastIcon.icon className={cn("h-[16px] text-foreground", toastIcon.iconColor)} />
        )}
        <span className={"font-normal leading-5"}>{title}</span>
      </div>
    ) as unknown as string
  };
};

const VARIANT_ICON_MAP = {
  default: { icon: ShapeCircleIcon, iconColor: "text-foreground" },
  success: { icon: TickCircleOutlineIcon, iconColor: "text-foreground" },
  error: { icon: AlertCircleRedIcon, iconColor: "text-foreground" },
  warn: { icon: WarnTriangleIcon, iconColor: "text-foreground" },
  info: { icon: InfoCircleIcon, iconColor: "text-[#0070F3]" }
};
